import { COLORS, colors } from '@constants/colors';
import { IStyles } from '@interfaces/styles';

export const useStyles = (): IStyles => {
  return {
    root: {
      width: '100%',
    },

    label: {
      color: COLORS.WHITE,
      position: 'relative',
      border: 'none',
      width: '100% !important',
      textAlign: 'left',
      fontSize: 14,
      fontWeight: 500,
      letterSpacing: '0.02em',
      transform: 'unset',

      '&.Mui-focused': {
        color: COLORS.WHITE,
      },
    },

    select: {
      flexDirection: 'row-reverse',
      width: '100%',
      height: 32,
      color: COLORS.WHITE,

      '& .MuiInput-input': {
        pl: 1,
        letterSpacing: '-0.04em',
      },

      '&.Mui-disabled': {
        color: COLORS.WHITE,
        cursor: 'no-drop',
      },
      '& .MuiInput-input.Mui-disabled': {
        cursor: 'no-drop',
        WebkitTextFillColor: 'unset',
      },

      '&.MuiInputBase-formControl': {
        mt: 1,
        backgroundColor: '#03030366',
        borderRadius: 1,
      },

      '.MuiSelect-select': {
        pr: '32px !important',
        width: 320,
        boxSizing: 'border-box',
        borderRadius: 1,
      },

      '& svg': {
        color: COLORS.WHITE,
        right: 6,
      },
      '& .selectIcon': {
        ml: 1,
        opacity: 0.5,
        color: COLORS.AZURE,
      },
    },

    menuPaper: {
      backgroundColor: colors.black,
      border: '0.5px solid rgba(255, 255, 255, 0.15)',
      borderRadius: '8px',
      boxShadow: '0 2px 8px rgba(0, 0, 0, 0.4)',
      marginTop: '4px',
    },

    menuList: {
      padding: '4px 0',
    },

    menuItem: {
      fontSize: 14,
      color: colors.white_80,
      '&:hover': {
        backgroundColor: colors.white_10,
      },
      '&.Mui-selected': {
        backgroundColor: colors.white_20,
      },
      '&.Mui-selected:hover': {
        backgroundColor: colors.white_20,
      },
    },
  };
};
